/**
 * アプリケーション全体で共有するランタイム状態。
 * 初期化は app.js の DOMContentLoaded で行う。
 */
export const app = {
  html: null,
  body: null,
  DeviceCheck: null,
  Root: null,
}

/** デバッグ用。コンソールから window._app で参照できる */
export function bindAppToWindow() {
  window._app = app
}
